import { Map } from "@iventis/mapbox-gl";
import { Position } from "geojson";
import { UnitOfMeasurement } from "@iventis/domain-model/model/unitOfMeasurement";
import { BehaviorSubject } from "rxjs";
import { iventisPointToAggregateLayer } from "../mapbox/engine-mapbox-helpers";
import { SupportedMapboxLayer } from "../mapbox/sublayer-types";
import { SnapIndicatorLayer } from "../generic-layers/snap-indicator-layer";
import { MapState } from "../../types/store-schema";

/** Mapbox layer which shows where a map object is going to snap to when drawing or editing */
export class MapboxSnapIndicatorLayer extends SnapIndicatorLayer {
    private readonly map: Map;

    private mapboxLayers: SupportedMapboxLayer[] = [];

    constructor(map: Map, state$: BehaviorSubject<MapState>) {
        super(state$);
        this.map = map;
        this.addLocalSource();
        this.addLayer();
    }

    protected addLayer() {
        this.mapboxLayers = iventisPointToAggregateLayer(this.snapIndicatorLayer, false, { projectDataFields: [], unitOfMeasurement: UnitOfMeasurement.Metric }, null, null).map(
            (layer) => layer.layer
        );

        this.mapboxLayers.forEach((layer) => {
            this.map.addLayer(layer);
        });
    }

    public removeLayer() {
        this.mapboxLayers.forEach((layer) => {
            if (this.map.getLayer(layer.id)) {
                this.map.removeLayer(layer.id);
            }
        });
    }

    protected addLocalSource() {
        this.map.addSource(this.sourceId, { type: "geojson", data: { type: "FeatureCollection", features: this.source ? this.source : [] } });
    }

    public removeLocalSource() {
        if (this.map.getSource(this.sourceId)) {
            this.map.removeSource(this.sourceId);
        }
    }

    public updateLocalSource(updatedPoint: Position | undefined) {
        super.updateLocalSource(updatedPoint);
        const source = this.map.getSource(this.sourceId);
        if (source.type === "geojson") {
            source.setData({ type: "FeatureCollection", features: this.source });
        }
    }

    public getLayerIdsForSnapping(): string[] {
        throw new Error("Method not implemented.");
    }

    protected updateStyle(): void {
        throw new Error("Method not implemented.");
    }

    protected hideLayer(): void {
        throw new Error("Method not implemented.");
    }

    protected showLayer(): void {
        throw new Error("Method not implemented.");
    }

    protected updateMapOrder(): void {
        throw new Error("Method not implemented.");
    }

    protected updateMapLevel(): void {
        throw new Error("Method not implemented.");
    }
}
